import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from '@/pages/home/components/HeroSection';
import CategoryNav from '@/pages/home/components/CategoryNav';
import HotArticles from '@/pages/home/components/HotArticles';
import LatestArticles from '@/pages/home/components/LatestArticles';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '黑料社区',
    url: 'https://heiliaoshequ.com',
    description: '黑料社区是专注于明星八卦、网红爆料、娱乐圈内幕的内容聚集平台。用户可自由分享、讨论、挖掘各类热门人物的真实动态与独家内幕，第一时间掌握圈内最劲爆资讯。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://heiliaoshequ.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '黑料社区',
    url: 'https://heiliaoshequ.com',
    description: '明星八卦、网红爆料、娱乐圈内幕聚集平台',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'tips@heiliaoshequ.com',
      contactType: '爆料投稿',
    },
  };

  return (
    <>
      <SEOHead
        title="明星八卦爆料聚集地"
        description="黑料社区是专注于明星八卦、网红爆料、娱乐圈内幕的内容聚集平台。在黑料社区，用户可自由分享、讨论、挖掘各类热门人物的真实动态与独家内幕，第一时间掌握圈内最劲爆资讯。"
        keywords="黑料社区,黑料社区爆料,黑料社区明星八卦,黑料社区娱乐圈内幕,黑料社区网红曝光,黑料爆料平台,娱乐圈黑料聚集地"
        canonicalUrl="/"
      />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <HotArticles />
          <LatestArticles />
        </main>
        <Footer />
      </div>
    </>
  );
}